import styled from "styled-components";

export const TournamentItmWrapper = styled.div`
  margin: 20px 16px;

  > .header {
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
  }
`;
export const TournamentItmBack = styled.div<{ isItm: boolean }>`
  width: 100%;
  margin-top: 12px;
  border-radius: 12px;
  padding: 20px 15px;
  background: ${(p) => (p.isItm ? "#f0f0f0" : "#fff")};

  > .table {
    display: flex;
    flex-direction: column;
    gap: 5px;

    > .header {
      display: flex;
      align-items: center;
      width: 100%;
      height: 27px;
      border-radius: 10px;
      padding: 5px 10px;
      background: ${(p) => (p.isItm ? "#6436e7" : "#f0f0f0")};

      > .item {
        flex: 1;
        color: ${(p) => (p.isItm ? "#ffffff" : "#000")};

        font-weight: 600;
        font-size: 12px;
        text-align: center;
        border-right: 1px solid #fff;

        &:last-child {
          border-right: none;
        }
      }
    }

    > .body {
      display: flex;
      flex-direction: column;

      > .no-data {
        font-weight: 600;
        font-size: 12px;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
`;

export const TournamentItmItem = styled.div`
  height: 27px;
  display: flex;
  align-items: center;

  > .item {
    flex: 1;

    font-weight: 600;
    font-size: 12px;
    text-align: center;
  }
`;

export const TournamentSininWrapper = styled.div`
  background: #f0f0f0;
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
  min-height: 54px;
  padding: 12px 16px;

  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .title {
      font-weight: 700;
      font-size: 16px;
    }
  }
`;
